import React, { useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import { BodyMediumText } from '@prisjakt/ui/text/variants';
import { SortOptions } from '../../offer-list-sorting/sort-options';
import { AllFilters } from './all-filters';
import { IOfferlistFilters } from '../types';
import { StyledModal, Header } from '../styles';

export const FiltersModal: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<IOfferlistFilters>
>> = props => {
  const { closeHandler } = props;
  const { t } = useContext(AppContext);

  return (
    <StyledModal
      isOpen
      onRequestClose={closeHandler}
      shouldShowCloseIcon
      width="inherit"
    >
      <Header>
        <BodyMediumText>{t('filter', 'filter.title')}:</BodyMediumText>
      </Header>
      <AllFilters />
      <Header>
        <BodyMediumText>{t('common', 'sort.title')}:</BodyMediumText>
      </Header>
      <SortOptions renderAllOptions />
    </StyledModal>
  );
};
